import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { injectIntl } from 'react-intl';

import { showHeaderFlashMessage } from '@client/redux/modules/flashMessage/actions';
import { FLASH_MESSAGE_TYPE_SUCCESS } from '@client/config/constants';

import { getCurrentPage } from '@client/redux/modules/routing/selectors';

import {
    Popover,
    TimeLeftBold
} from '../../shared/Shared';

import Reminder from './Reminder';
import OpenReminder from './OpenReminder';
import internalStyles from './upcomingCampaign.scss';

/* eslint-disable react/no-did-mount-set-state */
export class UpcomingCampaign extends React.Component {

    constructor() {
        super();
        this.state = {
            isOpen: false
        };
        this.updateOpenState = this.updateOpenState.bind(this);
        this.pageRefresh = this.pageRefresh.bind(this);
    }

    render() {
        const {
            campaign,
            campaignStyles,
            showPopover,
            closePopover,
        } = this.props;

        const {
            isOpen
        } = this.state;

        const campaignId = `campaign-${campaign.campaignIdentifier}`;
        const coverWithoutLogo = !campaign.hasLogo;

        return (
            <div
                id={campaignId}
                styleName="wrapper"
                style={campaignStyles}
            >
                <div styleName="inner-wrapper">
                    {coverWithoutLogo && (
                        <div styleName="title-label">
                            {campaign.name}
                        </div>
                    )}
                    <div styleName="info">
                        <div styleName="info-label-wrapper">
                            <div styleName="info-label-time">
                                <span styleName="info-time">
                                    <TimeLeftBold dateTill={campaign.dateStart} isUpcoming={true} expiredCallback={this.updateOpenState} />
                                </span>
                            </div>
                        </div>
                        { isOpen ? <OpenReminder campaign={campaign} /> : <Reminder campaign={campaign} />}
                    </div>
                </div>
                {showPopover &&
                    <Popover
                        closePopover={closePopover}
                        position="bottom"
                        title="campaigns.upcomingTooltipTitle"
                        content="campaigns.upcomingTooltipContent"
                    />
                }
            </div>
        );
    }

    componentDidMount() {
        if (this.props.showPopover) {
            const element = document.getElementById(`campaign-${this.props.campaign.campaignIdentifier}`);
            // we need to do this because the position of the element changes
            // several times so we need to calculate it based on its last one.
            this.scrollTimeout = setTimeout(() => {
                element.scrollIntoView();
            }, 500);
        }
    }

    componentWillUnmount = () => {
        this.clearTimeout();
    }

    clearTimeout = () => {
        if (this.scrollTimeout) {
            clearTimeout(this.scrollTimeout);
            this.scrollTimeout = null;
        }
    }

    updateOpenState() {
        if (!this.state.isOpen) {
            this.setState({ isOpen: true });
            this.props.showHeaderFlashMessage(
                FLASH_MESSAGE_TYPE_SUCCESS,
                this.props.intl.formatMessage({ id: 'campaigns.upcomingCampaignActive' }),
                'LoadIcon',
                this.pageRefresh
            );
        }
    }

    // When an upcoming campaign goes live, clicking the flash message should trigger a page reload
    pageRefresh() {
        window.location.reload();
    }
}

UpcomingCampaign.propTypes = {
    campaign: PropTypes.object.isRequired,
    campaignStyles: PropTypes.object,
    showPopover: PropTypes.bool.isRequired,
    columnCount: PropTypes.number,
    closePopover: PropTypes.func,
    showHeaderFlashMessage: PropTypes.func.isRequired,
    intl: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
    currentPage: getCurrentPage(state)
});

export default compose(
    connect(mapStateToProps, { showHeaderFlashMessage }),
    injectIntl,
    CSSModules(internalStyles, { allowMultiple: true })
)(UpcomingCampaign);
